var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idea-header-wrapper"},[_c('header',{staticClass:"text-center d-flex justify-content-center flex-column align-items-center"},[_c('h1',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mb-0 mx-3"},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }